import { render, staticRenderFns } from "./Symptoms.vue?vue&type=template&id=405b54ce&scoped=true&"
import script from "./Symptoms.vue?vue&type=script&lang=js&"
export * from "./Symptoms.vue?vue&type=script&lang=js&"
import style0 from "./Symptoms.vue?vue&type=style&index=0&id=405b54ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405b54ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VFlex,VRow})
